<template>
  <van-popup
    v-model="show"
    get-container="body"
    position="top"
    :overlay="false"
    class="routerMenuList"
  >
    <div class="main">
      <div
        :class="{ activeItem: pageName === 'home' }"
        class="listItem"
        @click="jumpMenu('home')"
      >
        {{ $t('publicNavigation.navList.item1') }}
      </div>
      <div
        class="listItem products"
        :class="{ activeItem: pageName === 'product' }"
        @click="isProduct = !isProduct"
      >
        <span>{{ $t('publicNavigation.navList.item2') }}</span>
        <img
          v-if="isProduct"
          src="@/assets/PC/navigation/Product-up.png"
          alt=""
        />
        <img v-else src="@/assets/PC/navigation/Product-down.png" alt="" />
      </div>
      <template v-if="isProduct">
        <div
          class="productItem"
          @click="jumpProductPage(item.router)"
          v-for="(item, index) in productList"
          :key="index"
        >
          <div class="info">
            <img :src="item.src" alt="" />
            <span>{{ $t(`publicNavigation.menuList.${item.title}`) }}</span>
          </div>
          <div class="introduce">
            {{ $t(`publicNavigation.menuList.${item.subTitle}`) }}
          </div>
        </div>
      </template>
      <div
        class="listItem"
        :class="{ activeItem: pageName === 'solution' }"
        @click="jumpMenu('solution')"
      >
        {{ $t('publicNavigation.navList.item3') }}
      </div>
      <div
        class="listItem"
        :class="{ activeItem: pageName === 'company' }"
        @click="jumpMenu('company')"
      >
        {{ $t('publicNavigation.navList.item4') }}
      </div>
    </div>
    <!-- <div class="experience">{{ $t('tryForFree') }}</div> -->
    <mobilePublicTryForFree
      text="tryForFree"
      class="experience"
    ></mobilePublicTryForFree>
  </van-popup>
</template>

<script>
export default {
  data () {
    return {
      show: true,
      isProduct: false,
      productList: [
        {
          src: require('@/assets/PC/navigation/EKYC.png'),
          title: 'item1Title',
          subTitle: 'item1Subtitle',
          router: 'ekyc'
        },
        {
          src: require('@/assets/PC/navigation/CreditScore.png'),
          title: 'item2Title',
          subTitle: 'item2Subtitle',
          router: 'creditScore'
        },
        {
          src: require('@/assets/PC/navigation/Anti-fraud.png'),
          title: 'item3Title',
          subTitle: 'item3Subtitle',
          router: 'antiFraud'
        },
        {
          src: require('@/assets/PC/navigation/Luna AI.png'),
          title: 'item4Title',
          subTitle: 'item4Subtitle',
          router: 'lunaAi'
        },
        {
          src: require('@/assets/PC/navigation/Intelligent-Overseas-Market.png'),
          title: 'item5Title',
          subTitle: 'item5Subtitle',
          router: 'aiAds'
        }
      ],
      pageName: localStorage.getItem('pageName') || 'home'
    }
  },
  created () {
    this.isIds()
  },
  mounted () {
    const productNameList = ['ekyc', 'creditScore', 'antiFraud', 'lunaAi', 'aiAds']
    if (productNameList.includes(this.$route.name)) {
      this.pageName = 'product'
    } else {
      this.pageName = this.$route.name
    }
  },
  methods: {
    jumpMenu (name) {
      if (this.$route.name === name) {
        window.location.reload()
      } else {
        this.$router.push({ name })
      }
      localStorage.setItem('pageName', this.pageName)
    },
    jumpProductPage (router) {
      if (this.$route.name === router) {
        window.scrollTo(0, 0)
        this.isProduct = !this.isProduct
      } else {
        this.$router.push({ name: router })
      }
    },
    isIds () {
      if (this.$i18n.locale === 'id') {
        this.productList = this.productList.filter(item =>
          item.router === 'creditScore' || item.router === 'antiFraud'
        )
      }
    }
  }
}
</script>

<style scoped lang="less">
.routerMenuList {
  width: 100%;
  padding: 0.43rem;
  background-color: rgba(255, 255, 255, 0.9);
  transform: translateY(1.28rem);
  .listItem {
    color: #242b2a;
    font-size: 0.43rem;
    text-align: left;
    margin: 0.43rem 0;
  }
  .activeItem {
    color: #07816a;
    font-weight: 500;
    font-weight: 500;
  }
  .products {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 0.43rem;
    }
    img {
      width: 0.43rem;
      height: 0.43rem;
      margin-right: 0.48rem;
    }
  }
  .productItem {
    padding: 0.53rem;
    background-color: #f7f9f8;
    border-radius: 0.21rem;
    margin: 0.43rem 0;
    text-align: left;
    .info {
      display: flex;
      align-items: center;
      margin-bottom: 0.27rem;
      img {
        height: 0.64rem;
        margin-right: 0.16rem;
      }
      span {
        color: #242b2a;
        font-size: 0.43rem;
        font-weight: 500;
      }
    }
    .introduce {
      color: #242b2a;
      font-size: 0.27rem;
    }
  }
  .experience {
    height: 1.28rem;
    width: 90%;
    background-color: #242b2a;
    border-radius: 0.85rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 0.43rem;
    font-weight: bold;
    position: absolute;
    bottom: 1.33rem;
  }
}
.main {
  height: 90vh;
  overflow: auto;
  padding-bottom: 2.67rem;
}
</style>
